<template>
    <guest-layout :background-class="'bg-gray-50'" :color-scheme="'light'" :poper-absolute="true" :footer="false">
        <template #top>
            <svg class="absolute bottom-0 right-0 transform translate-x-1/2 mb-48 text-gray-200 lg:top-0 lg:mt-28 lg:mb-0 xl:transform-none xl:translate-x-0" width="364" height="384" viewBox="0 0 364 384" fill="none">
                <defs>
                    <pattern id="eab71dd9-9d7a-47bd-8044-256344ee00d0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4" height="4" fill="currentColor" />
                    </pattern>
                </defs>
                <rect width="364" height="384" fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)" />
            </svg>
        </template>

        <div class="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 h-[100vh]">
            <div class="sm:mx-auto sm:w-full sm:max-w-md">
                <slot name="logo" />
            </div>

          <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px] border border-gray-200 rounded-md">
            <div class="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-12">
                <slot />
            </div>
          </div>

        </div>

      <x-footer/>
    </guest-layout>

</template>
<script>
import GuestLayout from "@/Layouts/GuestLayout";
import XFooter from "@/Layouts/Guest/Footer";
export default {
    components: {GuestLayout, XFooter}
}
</script>
